module.exports = __webpack_public_path__ + "static/media/part-detail-slide-5.fedec33c.jpg";